<template>
    <div class="animated fadeIn">
      <table class="table">
        <thead>
        <tr>
          <th>Type</th>
          <th>Status</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Cancelled Date</th>
          <th>View</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(member, key) in memberships">
          <td><app-btn :text="member.type"></app-btn></td>
          <td><app-btn :text="member.status"></app-btn></td>
          <td>{{ member.startAt|moment("DD/MM/YYYY") }}</td>
          <td>{{ member.endAt|moment("DD/MM/YYYY") }}</td>
          <td>{{ member.cancelledAt|moment("DD/MM/YYYY") }}</td>
          <td><membership-view-button :membership="member"></membership-view-button></td>
          <td>
            <membership-action-buttons
              v-bind:membership="member"
              @cancelled="onCancelled($event, key)"
              @paid="onPaid($event, key)"
            ></membership-action-buttons>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</template>
<script>
  import AppBtn from "../base/AppBtn";
  import MembershipActionButtons from "./MembershipActionButtons";
  import Vue from 'vue'
  import MembershipViewButton from "./buttons/MembershipViewButton";

  export default {
      name: 'membership-table',
      components: {
          MembershipViewButton,
          MembershipActionButtons,
          AppBtn,
      },
      props: {
          memberships: {
              type: Array,
              default: new Array(),
          },
      },
      methods: {
          onCancelled(member, key) {
              Vue.set(this.memberships, key, member)
          },
          onPaid(member, key) {
              Vue.set(this.memberships, key, member)
          },
      },
  }
</script>
